import Joi from "joi";

export const loginValidator = (data) => {
  const schema = Joi.object({
    email: Joi.string()
      .email({
        tlds: {
          allow: false,
        },
      })
      .required()
      .messages({
        "string.empty": `"email" tidak boleh kosong`,
        "string.email": `"${data.email}" bukan email yang valid`,
      }),
    password: Joi.string().required().messages({
      "string.empty": `"password" tidak boleh kosong`,
    }),
  });
  return schema.validate(data);
};

export const forgotPasswordValidator = (data) => {
  const schema = Joi.object({
    email: Joi.string()
      .email({
        tlds: {
          allow: false,
        },
      })
      .required()
      .messages({
        "string.empty": `"email" tidak boleh kosong`,
        "string.email": `"${data.email}" bukan email yang valid`,
      }),
  });
  return schema.validate(data);
};
